import { DELIVERY_SERVICE_TYPES, TAKEOUT_SERVICE_TYPE } from '../constants/payments'

export const isTakeoutOrders = payment => payment?.serviceType && payment.serviceType === TAKEOUT_SERVICE_TYPE
export const isDeliveryOrders = payment => payment?.serviceType && DELIVERY_SERVICE_TYPES.includes(payment.serviceType)
